enum QuotaMergeMode {
    SET = 'set',
    SUM = 'sum',
}

export default QuotaMergeMode;
